import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Category} from "../../models/category";

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../models";

@Component({
    selector: 'customer-form-dialog',
    templateUrl: './customerDescriptionEditDialog.component.html',
    styleUrls: ['./customerDescriptionEditDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CustomerDescriptionEditDialogComponent {
    action: string;
    customer: User;
    dialogTitle: string;
    customerForm: FormGroup;

    /**
     * Constructor
     *
     * @param {MatDialogRef<CustomerDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        public matDialogRef: MatDialogRef<CustomerDescriptionEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;
        this.customer = _data.customer;

        this.customerForm = this.createCustomerForm();
    }

    createCustomerForm(): FormGroup {
        return this._formBuilder.group({
            description: [this.customer.description],
        });
    }

}
